
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg" style={{ fontFamily: '"Pacifico", serif' }}>D</span>
            </div>
            <span className="text-xl font-bold text-gray-800" style={{ fontFamily: '"Pacifico", serif' }}>Data Metanoia</span>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Inicio</a>
            <a href="/#servicios" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Servicios</a>
            <a href="/#nosotros" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Nosotros</a>
            <a href="/#casos" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Casos de Éxito</a>
            <a href="/impulso-digital" className="text-blue-600 hover:text-blue-700 font-semibold transition-colors cursor-pointer">Tu Salto Digital</a>
            <a href="/#contacto" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Contacto</a>
          </nav>
          
          <div className="hidden md:flex items-center space-x-4">
            <Button variant="outline" size="sm">Consulta Gratis</Button>
          </div>
          
          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className={`w-6 h-6 ${isMenuOpen ? 'hidden' : 'block'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg className={`w-6 h-6 ${isMenuOpen ? 'block' : 'hidden'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t">
            <nav className="flex flex-col space-y-4 pt-4">
              <a href="/" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Inicio</a>
              <a href="/#servicios" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Servicios</a>
              <a href="/#nosotros" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Nosotros</a>
              <a href="/#casos" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Casos de Éxito</a>
              <a href="/impulso-digital" className="text-blue-600 hover:text-blue-700 font-semibold transition-colors cursor-pointer">Tu Salto Digital</a>
              <a href="/#contacto" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Contacto</a>
              <Button variant="outline" size="sm" className="mt-2 w-fit">Consulta Gratis</Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
